import { sanitizeUrl } from '@braintree/sanitize-url'

export const redirectTo = (url: string) => {
    const urlSanitized = sanitizeUrl(url)

    if (urlSanitized === 'about:blank') {
        console.error('Invalid URL ' + url)
        alert('Invalid URL')
    } else {
        window.location.href = urlSanitized
    }

}
